import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { toast } from 'react-toastify'
import { motion } from 'framer-motion'
import { register } from '../../store/actions/authActions'
import Button from '../../components/Button'

const validEmailRegex = RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);

const Register = (props) => {
    const initState = {
        email: '',
        username: '',
        password: '',
        reEnterPassword: '',
        errors: {}
    }

    const [formState, setFormState] = useState(initState)

    const dispatch = useDispatch()
    const authState = useSelector(state => state.auth)

    const { isLoggedIn } = authState

    const handleSubmit = (event) => {
        event.preventDefault();
        let { email, username, password, errors } = formState
        console.log(Object.keys(errors).length)

        if (Object.keys(errors).length === 0) {
            let informationForUser = {
                email: email,
                username: username,
                password: password,
            }
            dispatch(register(informationForUser, null))
            setFormState(initState)
        } else {
            toast.error('Não foi possível concluir o registo, verifique as mensagens de erro dos campos de texto!');
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        let checkErr = formState.errors;

        if (value === '') {
            checkErr = { ...checkErr, [name]: '' }
        } else {
            switch (name) {
                case 'email':
                    if (!validEmailRegex.test(value)) {
                        checkErr = { ...checkErr, [name]: 'O email inserido não é valido. Por insira um email valido.' }
                    } else {
                        delete errors.email
                    }
                    break;
                case 'username':
                    if (value.length < 5 || value.length > 10) {
                        checkErr = { ...checkErr, [name]: 'Por favor insira um nome entre 5 e 10 caracteres.' }
                    } else {
                        delete errors.username
                    }
                    break;
                case 'password':
                    if (value.length < 8) {
                        checkErr = { ...checkErr, [name]: 'Insira uma senha com pelo menos 8 caracteres.' };
                    } else {
                        delete errors.password
                    }
                    break;
                case 'reEnterPassword':
                    if (value !== formState.password && value.length !== formState.password.length) {
                        checkErr = { ...checkErr, [name]: 'As senhas não condizem, por favor insira novamente a senha correta' };
                    } else {
                        delete errors.reEnterPassword;
                    }
                    break;
                default:
                    checkErr = { ...checkErr };
                    break;
            }
        }

        setFormState({
            ...formState,
            errors: checkErr,
            [event.target.name]: event.target.value
        })
    }

    const spanError = (error) => {
        let { errors } = formState
        return (
            <motion.span
                initial={{ opacity: 0, y: -25, display: 'none' }}
                animate={errors?.[error] ?
                    { opacity: 1, y: 0, display: 'block' } :
                    { opacity: 0, y: -25, transitionEnd: { display: 'none' } }
                }
                transition={{ duration: 0.5, ease: 'easeInOut' }}
                className='bg-red-500 text-sm font-medium rounded text-white shadow p-2'
            >
                {(errors?.[error] && errors?.[error] !== '') && errors?.[error]}
            </motion.span>
        )
    }

    let { errors, email, username, password, reEnterPassword } = formState

    return (
        isLoggedIn ? <Redirect to='/dashboard' /> :
            <section id='register'>
                <h2 className='text-center my-2'>Registar</h2>
                <form>
                    <div className="mb-4">
                        <label className="block text-gray-700 font-bold mb-2">
                            <span>Nome</span>
                            <input required className="text-sm shadow appearance-none border rounded w-full py-2 px-3 my-3" type="text" placeholder="Escreva aqui o seu nome" value={username} name='username' onChange={handleChange} />
                            {spanError('username')}
                        </label>

                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 font-bold mb-2">
                            <span>Email</span>
                            <input required className="text-sm shadow appearance-none border rounded w-full py-2 px-3 my-3" type="text" placeholder="Escreva aqui o seu email" name='email' value={email} onChange={handleChange} />
                            {spanError('email')}
                        </label>
                    </div>

                    <div className="mb-4">
                        <label className="text-gray-700 font-bold mb-2">
                            <span>Palavra-passe</span>
                            <input required className="text-sm shadow appearance-none border rounded w-full py-2 px-3 my-3" type="password" placeholder="Escreva aqui a sua palavra-passe" name='password' value={password} onChange={handleChange} />
                            {spanError('password')}
                        </label>
                    </div>

                    <div className="mb-6">
                        <label className="text-gray-700 font-bold mb-2">
                            <span>Confimar Palavra-passe</span>
                            <input required className="text-sm shadow appearance-none border rounded w-full py-2 px-3 my-3" type="password" placeholder="Escreva aqui a sua palavra-passe" name='reEnterPassword' value={reEnterPassword} onChange={handleChange} />
                            {spanError('reEnterPassword')}
                        </label>
                    </div>

                    <p className='inline-block link text-sm mb-8' onClick={() => props.scrollFunction()}>
                        Já tem conta? Entre na jogo aqui.
                    </p>

                    <hr className='mb-6' />

                    <div className="flex float-right">
                        <Button className='mr-0 w-full' onClick={handleSubmit}>Continuar registo</Button>
                    </div>
                </form>
            </section>
    )
}

export default Register